import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab, Typography, useMediaQuery } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import StoreIcon from "@mui/icons-material/Store";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { useSelector } from "react-redux";
import BuyCommodity from "./BuyCommodity";
import SellCommodity from "./SellCommodity";
import ManageCommodity from "./ManageCommodity";
import { useGetUserBasicDetailsQuery } from "./ProcurementApiSlice";
import SellerCart from "./SellerCart";
import BuyerCart from "./BuyerCart";
import BuyerLeadList from "./BuyerLeadList";
import SampleDashboard from "components/analytics/SampleDashboard";
import CommudityMaster from "./CommudityMaster";
import EmandiProc from "./EmandiProc";
import { selectCurrentRoles } from "features/auth/authSlice";
import { Mandi } from "features/E-Mandi/EmandiReport/Mandi";
import EmandiReports from "features/E-Mandi/EmandiReport/emandiReport";

const BuyAndSell = React.memo(
  ({
    organizationVal,
    activeTabProject,
    projectOrgId,
    setActiveTabProject,
    showHeader,
  }) => {
    const { organization_id, given_name } = useSelector(selectCurrentRoles);
    const [user_id] = useState(projectOrgId ? projectOrgId : organization_id);

    // console.log("user_id",user_id,"----",organizationVal)
    const [activeTab, setActiveTab] = useState(
      activeTabProject || "Commodities"
    );
    // console.log("activeTab",activeTab)
    // console.log("showTab",activeTabProject)
    const { data, refetch: refetchBasicDetails } = useGetUserBasicDetailsQuery(
      { user_id },
      { refetchOnMountOrArgChange: true }
    );
    const [UserData, setUserData] = useState("");
    useEffect(() => {
      if (data) {
        setUserData(data.data);
      }
      if (activeTabProject) {
        setActiveTab(activeTabProject);
      }
    }, [data, activeTabProject, activeTab]);
    const handleTabChange = (event, newValue) => {
      setActiveTab(newValue);
    };
    const isMobile = useMediaQuery("(max-width:600px)");

    const tabs = [
      { label: "My Commodities", icon: <StoreIcon />, value: "Commodities" },
      organizationVal.procurement_type === "Buyer"
        ? { label: "Dashboard", icon: <DashboardIcon />, value: "Dashboard" }
        : {
            label: "Manage Stock",
            icon: <InventoryIcon />,
            value: "Manage Stocks",
          },
      {
        label: "Ongoing Trades",
        icon: <ShoppingCartCheckoutIcon />,
        value:
          organizationVal.procurement_type === "Buyer"
            ? "Buyer Cart"
            : "Seller Ongoing Trade",
      },

      organizationVal.procurement_type !== "Buyer"
        ? {
            label: "Create Trades",
            icon: <StorefrontIcon />,
            value: "Seller Initiated Trade",
          }
        : null,

      organizationVal.procurement_type === "Buyer"
        ? {
            label: "Initiated By Seller",
            icon: <StorefrontIcon />,
            value: "Self Initiated Trade Buyer",
          }
        : null,

      { label: "E-Mandi", icon: <StoreIcon />, value: "E-Mandi" },
    ].filter(Boolean);

    return (
      <div style={{ marginTop: isMobile ? "0px" : "-30px" }}>
        {showHeader && (
          <Box
            sx={{
              backgroundColor: "white",
              overflow: isMobile ? "scroll" : "hidden",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: "60px",
              paddingRight: "20px",
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              textColor="orange"
              indicatorColor="orange"
              sx={{
                display: "flex",
                justifyContent: isMobile ? "center" : "center",
                "& .MuiTab-root": {
                  minWidth: isMobile ? "10px" : "150px",
                  padding: isMobile ? "10px" : "16px",
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "center",
                  textTransform: "capitalize",
                  fontSize: "14px",
                  gap: isMobile ? "8px" : "12px",
                  color: "#555",
                  transition: "background-color 0.3s, color 0.3s",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    color: "orange",
                  },
                },
                "& .Mui-selected": {
                  color: "orange",
                  fontWeight: "medium",
                },
                "& .MuiTabs-indicator": {
                  display: "none",
                },
              }}
            >
              {tabs.map(
                (tab) =>
                  tab && (
                    <Tab
                      key={tab.value}
                      icon={tab.icon}
                      iconPosition="top"
                      label={tab.label}
                      value={tab.value}
                    />
                  )
              )}
            </Tabs>
          </Box>
        )}
        {/* <Box sx={{ p: 2, textAlign: "center", borderTop: "1px solid #e0e0e0" }}> */}
        <Box sx={{ p: { xs: 0, sm: 2, md: 2 } }}>
          {activeTab === "Commodities" && (
            <CommudityMaster
              setActiveCard={setActiveTab}
              organizationVal={organizationVal}
              activeCard={activeTab}
              user_id={user_id}
              userName={given_name}
              UserData={UserData?.erp_user}
              setActiveTabProject={setActiveTabProject}
              activeTabProject={activeTabProject}
            />
          )}
          {activeTab === "E-Mandi" && (
            //  <EmandiReports

            //          />
            <EmandiProc />
          )}
          {activeTab === "Dashboard" && <SampleDashboard />}
          {activeTab === "Self Initiated Trade Buyer" && (
            <BuyCommodity
              setActiveCard={setActiveTab}
              UserData={UserData?.erp_user}
              activeCard={activeTab}
              user_id={user_id}
              activeTabProject={activeTabProject}
            />
          )}
          {activeTab === "Seller Initiated Trade" && (
            <SellCommodity
              user_id={user_id}
              activeCard={activeTab}
              refetchBasicDetails={refetchBasicDetails}
              UserData={UserData}
              activeTabProject={activeTabProject}
            />
          )}
          {activeTab === "Seller Ongoing Trade" && (
            <SellerCart
              user_id={user_id}
              activeCard={activeTab}
              setActiveCard={setActiveTab}
              activeTabProject={activeTabProject}
            />
          )}
          {activeTab === "Buyer Cart" && (
            <BuyerCart
              user_id={user_id}
              activeCard={activeTab}
              UserData={UserData?.erp_user}
            />
          )}
          {activeTab === "Lead List" && (
            <BuyerLeadList
              user_id={user_id}
              UserData={UserData?.erp_user}
              activeCard={activeTab}
            />
          )}
          {activeTab === "Manage Stocks" && (
            <ManageCommodity
              user_id={user_id}
              userName={given_name}
              setActiveCard={setActiveTab}
              UserData={UserData?.erp_user}
              activeCard={activeTab}
              activeTabProject={activeTabProject}
              setActiveTabProject={setActiveTabProject}
            />
          )}
        </Box>
      </div>
    );
  }
);

export default BuyAndSell;
